import React, { useState } from 'react';
import { Box, TextField, Button, Card, CardContent, Typography, Alert, Grid } from '@mui/material';
import { usePostDataFetch } from '../../utils/useDataFetch';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const CreateTeam = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    const [teamName, setTeamName] = useState('');
    const { data: tData, error: tError, isLoading: tLoading, postData: createTeam } = usePostDataFetch();

    // Protection just in case
    if (user?.role !== 'trainer' && user?.role !== 'super_admin' && !user?.isAdmin) {
        return (
            <Box sx={{ p: 5, textAlign: 'center' }}>
                <Alert severity="error">Zugriff verweigert. Nur Trainer können Teams erstellen.</Alert>
                <Button sx={{ mt: 2 }} variant="contained" onClick={() => navigate('/')}>Zurück zum Feed</Button>
            </Box>
        );
    }

    const handleCreateTeam = (e) => {
        e.preventDefault();
        createTeam({ url: '/teams/team', aBody: { name: teamName } });
    };

    return (
        <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 800, margin: '0 auto' }}>
            <Typography variant="h4">Neues Team gründen</Typography>
            
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>Trage hier die Daten deines Teams ein:</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Die Team-Erstellung wird zur Genehmigung eingereicht. Nach der Bestätigung durch den Administrator kannst du Spieler einladen.
                    </Typography>

                    <form onSubmit={handleCreateTeam}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid size={{ xs: 12, md: 8 }}>
                                <TextField 
                                    fullWidth
                                    label="Teamname (z.B. 1. Herren, U19, D-Jugend)" 
                                    variant="outlined" 
                                    value={teamName} 
                                    onChange={(e) => setTeamName(e.target.value)} 
                                    required 
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Button fullWidth variant="contained" color="primary" type="submit" disabled={tLoading} size="large" sx={{ py: 1.5 }}>
                                    Team gründen
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                    
                    {tData?.success && (
                        <Alert severity="info" sx={{ mt: 3 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                                ⏳ Team-Erstellung ausstehend
                            </Typography>
                            <Typography variant="body2">
                               Warte bitte die Genehmigung ab. Sobald dein Team bestätigt wurde, kannst du Spieler einladen und loslegen!
                            </Typography>
                        </Alert>
                    )}
                    {tError && <Alert severity="error" sx={{ mt: 3 }}>{tError}</Alert>}
                </CardContent>
            </Card>
        </Box>
    );
};

export default CreateTeam;
